<template>
  <vue-perfect-scrollbar class="bbe-templates-quickly"
                         v-if="templatesList.length > 0 && position"
                         :style="{ left: leftPosition, top: topPosition }">
    <transition-group name="bbe-flip-list">
      <div v-for="(template, index) in templatesList"
           class="bbe-templates-quickly-item"
           @click="setTemplate(template)"
           :class="{'bbe-templates-quickly-item_hover': activeTemplate === index}"
           :key="template.id">
        <img :src="templateIcon" class="bbe-templates-quickly-item__icon"/>
        <span class="bbe-templates-quickly-item__name">
          {{template.name}}
        </span>
      </div>
    </transition-group>
  </vue-perfect-scrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {filter, get} from 'lodash'
import templatesApi from '@/api/Templates/api'
import icons from '@/constants/images'

export default {
  name: 'TemplateQuicklyAdd',
  props: ['position', 'keyword', 'quill', 'regexp'],
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      templatesList: [],
      templateIcon: icons.template,
      activeTemplate: false
    }
  },
  computed: {
    leftPosition () {
      const left = get(this.position, 'x', 0)
      return left + 'px'
    },
    topPosition () {
      const top = get(this.position, 'y', 0)
      const height = get(this.position, 'height', 0)
      return top + height + 4 + 'px'
    }
  },
  methods: {
    searchTemplates (keywords) {
      templatesApi.searchTemplates({keywords})
        .then(resp => {
          this.templatesList = filter(resp.data.templates, temp => temp)
        })
        .catch(err => {
          console.error(err)
        })
    },
    keyDown (e) {
      if (this.templatesList.length < 1 && !this.position) return
      e.stopPropagation()
      e.preventDefault()
      this.quill.editor.setAttribute('contenteditable', false)
      if (e.keyCode === 40) {
        this.setTemplateDown()
      } else if (e.keyCode === 38) {
        this.setTemplateUp()
      } else if (e.keyCode === 13) {
        this.setTemplate(this.templatesList[this.activeTemplate])
      } else if (e.keyCode === 27) {
        this.$emit('close')
      } else {
        this.quill.editor.setAttribute('contenteditable', true)
      }
    },
    setTemplate (template) {
      const startIndex = this.regexp.index
      const endIndex = startIndex + this.regexp[0].length
      const length = this.quill.value.length
      const start = this.quill.value.slice(0, startIndex)
      const end = this.quill.value.slice(endIndex, length)
      this.quill.value = ''
      this.quill.selection.insertHTML(start || '')
      this.quill.selection.insertHTML(template.content || '')
      this.quill.selection.insertHTML(end || '')
      this.$emit('close')
    },
    setTemplateDown () {
      const isLast = this.activeTemplate < this.templatesList.length - 1
      this.activeTemplate === false ? this.activeTemplate = 0 : this.activeTemplate += +isLast
    },
    setTemplateUp () {
      const isFirst = this.activeTemplate === 0
      this.activeTemplate === false ? this.activeTemplate = 0 : this.activeTemplate -= +!isFirst
    }
  },
  watch: {
    keyword () {
      this.searchTemplates(this.keyword)
    }
  },
  beforeMount () {
    document.addEventListener('keyup', this.keyDown, false)
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.keyDown, false)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-templates-quickly {
    position: fixed;
    background-color: $color-white;
    box-shadow: 0 0 13px rgba($color-accent, 0.18);
    border-radius: 6px;
    min-width: 245px;
    max-height: 297px;
    padding: 8px 0;

    &-item {
      display: flex;
      align-items: center;
      padding: 10px 14px;
      cursor: pointer;

      &:hover,
      &_hover {
        background-color: $color-gallery;
      }

      &__icon {
        margin-right: 15px;
        width: 29px;
      }

      &__name {
        color: $color-accent;
        font-weight: 500;
        font-size: 12px;
        line-height: 120.34%;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplateQuicklyAdd/TemplateQuicklyAdd.vue